__turbopack_context__.v({
  "attribute": "JobCard-module__4yausa__attribute",
  "attributeLabel": "JobCard-module__4yausa__attributeLabel",
  "attributes": "JobCard-module__4yausa__attributes",
  "avatarFallback": "JobCard-module__4yausa__avatarFallback",
  "avatarImage": "JobCard-module__4yausa__avatarImage",
  "avatarWrapper": "JobCard-module__4yausa__avatarWrapper",
  "card": "JobCard-module__4yausa__card",
  "description": "JobCard-module__4yausa__description",
  "emoji": "JobCard-module__4yausa__emoji",
  "headings": "JobCard-module__4yausa__headings",
  "name": "JobCard-module__4yausa__name",
  "recruiterLogo": "JobCard-module__4yausa__recruiterLogo",
  "root": "JobCard-module__4yausa__root",
  "title": "JobCard-module__4yausa__title",
  "top": "JobCard-module__4yausa__top",
});
